import React, { FC } from 'react'
import { FeedbackContainer } from '@rw1/shared-lib'
import { CUSTOM_PROTOCOL_SCHEMA } from '../../config'
import { Layout } from '../../layout'
import { useLocalization } from '../../localization'

export const ResetConfirmation: FC = () => {
  const { localize } = useLocalization()

  React.useEffect(() => {
    const scheme = CUSTOM_PROTOCOL_SCHEMA
    const requestLogoutURl = `${scheme}://requestLogout`
    window.location.replace(requestLogoutURl)
  }, [])

  return (
    <Layout>
      <FeedbackContainer
        description={localize('reset_password.confirmation_instructions')}
        title={localize('reset_password.confirmation')}
      />
    </Layout>
  )
}
